import React, { useEffect, useMemo, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ajaxUser from "../../util/remote/ajaxUser";
import functions from "../../util/functions";
import LeftAd from "../../components/Welcome/LeftAd";



const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const tokenInfo = functions.readUser(); // optional auth check

  const [password, setPassword] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [notify, setNotify] = useState(null);
  const [submitting, setSubmitting] = useState(false);


  const passwordInputType = useMemo(
    () => (showPwd ? "text" : "password"),
    [showPwd]
  );

  // Basic password rules: 8+ chars, at least one letter and one number
  const passwordValid = useMemo(() => {
    const p = password.trim();
    return p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p);
  }, [password]);

  const passwordsMatch = useMemo(
    () => password === confirmPwd,
    [password, confirmPwd]
  );

  const canSubmit = useMemo(
    () => tokenInfo && passwordValid && passwordsMatch && !submitting,
    [tokenInfo, passwordValid, passwordsMatch, submitting]
  );

  if (!tokenInfo) {
    return <Navigate to="/login" />;
  }

  const handleLogout = () => {
    localStorage.removeItem("ofc");
    navigate("/login");
    window.location.reload();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setSubmitting(true);
    const res = await ajaxUser.resetPassword(password);
    setSubmitting(false);

    if (res.status === "OK") {
      setNotify(
        <Notification
          message={`${res.message}... Redirecting...`}
          type="success"
        />
      );
      setTimeout(() => {
        handleLogout();
      }, 3000);
    } else {
      setNotify(<Notification message={res.message} type="danger" />);
    }
  };

  return (
    <div className="ofLoginRoot">
      <div className="ofLoginBg" />

      <div className="ofLoginWrap">
        <div className="ofLoginGrid">
          {/* LEFT: Benefits */}
          <LeftAd />

          {/* RIGHT: Form */}
          <div className="ofLoginRight">
            <div className="ofLoginCard">
              <div className="ofLoginHeader">
                <div className="ofLoginTitle">Set a new password</div>
                <div className="ofLoginSub">
                  Use a strong password you haven’t used before.
                </div>
              </div>

              {notify}

              <form onSubmit={handleSubmit} className="ofForm" noValidate>
                <div className="ofField">
                  <label htmlFor="password">New password</label>
                  <input
                    type={passwordInputType}
                    id="password"
                    placeholder="Enter new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                  />
                  <div
                    className="ofHint"
                    style={{
                      marginTop: 6,
                      fontSize: 12,
                      color: password
                        ? passwordValid
                          ? "rgba(16, 185, 129, 1)"
                          : "rgba(239, 68, 68, 1)"
                        : "rgba(11, 18, 32, 0.55)",
                    }}
                  >
                    Must be at least 8 characters and include a number.
                  </div>
                </div>

                <div className="ofField">
                  <label htmlFor="confirmPwd">Confirm new password</label>
                  <input
                    type={passwordInputType}
                    id="confirmPwd"
                    placeholder="Retype new password"
                    value={confirmPwd}
                    onChange={(e) => setConfirmPwd(e.target.value)}
                    required
                    autoComplete="new-password"
                  />

                  {confirmPwd.length > 0 && (
                    <div
                      className="ofHint"
                      style={{
                        marginTop: 6,
                        fontSize: 12,
                        color: passwordsMatch
                          ? "rgba(16, 185, 129, 1)"
                          : "rgba(239, 68, 68, 1)",
                      }}
                    >
                      {passwordsMatch ? "Passwords match." : "Passwords do not match."}
                    </div>
                  )}
                </div>

                <div className="ofRow" style={{ marginTop: 6 }}>
                  <label className="ofCheck">
                    <input
                      type="checkbox"
                      checked={showPwd}
                      onChange={() => setShowPwd((s) => !s)}
                    />
                    <span>Show password</span>
                  </label>

                  <Link to="/login" className="ofLink">
                    Back to sign in
                  </Link>
                </div>

                <button className="ofBtn" type="submit" disabled={!canSubmit}>
                  {submitting ? "Updating…" : "Set new password"}
                </button>

                <div className="ofFooter" style={{ marginTop: 12 }}>
                  After updating, you’ll be logged out and asked to sign in again.
                </div>
              </form>
            </div>

            <div className="ofLegal">
              Tip: Use a mix of letters, numbers, and a unique phrase you can remember.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
